let progressBarStatus;
let navigationArrows;
progressBarStatus = window.progressbar;
navigationArrows = window.navigationArrows;
window.initializeUpsell = () => {
  const isCollection = document.querySelector("#upsellSliderCollection");
  const collectionData = JSON.parse(isCollection.textContent);
  if (!isCollection) {
    fetch("/cart.js", { credentials: "same-origin" })
      .then((response) => response.json())
      .then((data) => {
        // const cartItems = data.items
        const cartItems = data.items.filter((item) => {
          if (item.properties && typeof item.properties === "object") {
            return !item.properties.hasOwnProperty("__discount");
          }
          return true;
        });
        if (cartItems.length > 0) {
          const cartItemIds = [];
          cartItems.forEach((item) => {
            cartItemIds.push(item.product_id);
          });
          fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${cartItemIds[0]}&limit=10&intent=related`)
            .then((response) => response.json())
            .then((data) => {
              const recommendedProducts = data.products;
              const swiperWrapper = document.querySelector(".swiper-wrapper.upsell-slider");
              const loading = document.querySelector("#loading-upsell");
              recommendedProducts.forEach((product) => {
                const slide = document.createElement("div");
                slide.classList.add("swiper-slide");
                const imageWrapper = createImg(product);
                slide.appendChild(imageWrapper);
                const infoWrapper = createInfoWrapper(product);
                slide.appendChild(infoWrapper);
                swiperWrapper.appendChild(slide);
              });
              const slider = swiper();
              slider.update();
			  
            });
        }
      });
  } else {
    const recommendedProducts = collectionData;
    const swiperWrapper = document.querySelector(".swiper-wrapper.upsell-slider");
    const loading = document.querySelector("#loading-upsell");
    recommendedProducts.forEach((product) => {
      const slide = document.createElement("div");
      slide.classList.add("swiper-slide");
      const imageWrapper = createImg(product);
      slide.appendChild(imageWrapper);
      const infoWrapper = createInfoWrapper(product);
      slide.appendChild(infoWrapper);
      swiperWrapper.appendChild(slide);
    });
    const slider = swiper();
    slider.update();
  }
};

async function renderShopifySection(sections) {
  try {
    const response = await fetch(`?sections=${sections}`);
    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }
    const html = await response.json();
    return html;
  } catch (error) {
    console.error(`Error: ${error.message}`);
  }
}

const createImg = (product) => {
  const imageWrapper = document.createElement("a");
  imageWrapper.classList.add("upsell__link");
  imageWrapper.href= '/products/' + product.handle;
  const image = document.createElement("img");
  image.setAttribute("loading", "lazy");
  image.src = product.featured_image;
  image.alt = "Upsell Product";
  image.height = 121;
  image.width = 120;
  imageWrapper.appendChild(image);

  return imageWrapper;
};

const createInfoWrapper = (product) => {
  const infoWrapper = document.createElement("div");
  infoWrapper.classList.add("cart-item__details");

  const titleWrapper = document.createElement("div");
  titleWrapper.classList.add("upsell__title-wrap");

  const title = document.createElement("a");
  title.classList.add("cart-item__name", "h4", "break");
  title.href = product.url;
  title.textContent = product.title;
  titleWrapper.appendChild(title);

  const variantPrice = product.price;
  const variantComparePrice = product.compare_at_price;

  const priceWrapper = document.createElement("div");
  priceWrapper.classList.add("cart-item__price-wrapper");
  const price = document.createElement("span");
  price.classList.add("price", "price--end");
  price.textContent = (Number(variantPrice) / 100).toFixed(2) + "€";
  priceWrapper.appendChild(price);

  if (variantPrice < variantComparePrice) {
    const comparePrice = document.createElement("span");
    const tachado = document.createElement("s");
    tachado.classList.add("price-item", "price-item--regular");
    tachado.textContent = (Number(variantComparePrice) / 100).toFixed(2) + "€";
    comparePrice.appendChild(tachado);
    priceWrapper.appendChild(comparePrice);
  }
  titleWrapper.appendChild(priceWrapper);

  if (variantPrice < variantComparePrice) {
    const savePrice = document.createElement("span");
    savePrice.classList.add("ahorra");
    savePrice.textContent = "Ahorras " + ((Number(variantComparePrice) - Number(variantPrice)) / 100).toFixed(2) + "€";
    titleWrapper.appendChild(savePrice);
  }

  infoWrapper.appendChild(titleWrapper);

  const bottomWrapper = document.createElement("div");
  bottomWrapper.classList.add("upsell__bottom");

const firstVariant = product.variants.find((v) => v.available);

const addToCartButton = document.createElement("button");
addToCartButton.classList.add("upsell__button", "button", "button--primary");

if (product.variants.length > 1) {
  // Si el producto tiene más de una variación
  addToCartButton.innerHTML = `Ver producto`;
  addToCartButton.onclick = () => {
    window.location.href = '/products/' + product.handle; // Redirige a la URL del producto
  };
} else {
  // Si el producto tiene una sola variación
  addToCartButton.innerHTML = `Añadir`;
  addToCartButton.onclick = () => {
    console.log("---------------------", addToCartButton);

    addToCartButton.innerHTML = addToCartButton.innerText + `<div class="loading-overlay__spinner" id="loading-upsell">
      <svg
        aria-hidden="true"
        focusable="false"
        class="spinner"
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>
    </div>`;
    addToCart(firstVariant, addToCartButton);
  };
}

bottomWrapper.appendChild(addToCartButton);
infoWrapper.appendChild(bottomWrapper);
return infoWrapper;
};


var init_num = 0;
const addToCart = (firstVariant, btn) => {

  init_num ++;

  let barWrapper;

  const quantity = 1;
  const item = { id: firstVariant.id, quantity: quantity };

  const upsellWrapper = document.querySelector(".convertlab__upsell");
  const cartWrapper = document.querySelector("cart-drawer-items");

  if (progressBarStatus) {
    barWrapper = document.querySelector(".drawer__progress-bar");
  }

  // const sliderContainer = document.querySelector(".upsell-slider__container");
  // sliderContainer.innerHTML = `<div class="loading-overlay__spinner" id="loading-upsell">
	// 	<svg
	// 		aria-hidden="true"
	// 		focusable="false"
	// 		class="spinner"
	// 		viewBox="0 0 66 66"
	// 		xmlns="http://www.w3.org/2000/svg"
	// 	>
	// 		<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
	// 	</svg>
	// </div>`;

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(item),
  })
    .then((response) => response.json())
    .then(async (data) => {
	let barRewards;
      const drawerItems = await renderShopifySection("cart-drawer-items");

      if (progressBarStatus) {
        barRewards = await renderShopifySection("cart-bar-rewards");
      }

      const upsellItems = await renderShopifySection("convertlab-upsell-slider");

      if (drawerItems && upsellItems) {
        cartWrapper.innerHTML = stringToHTML(drawerItems["cart-drawer-items"]).outerHTML;
        // upsellWrapper.innerHTML = stringToHTML(upsellItems["convertlab-upsell-slider"]).outerHTML;
        if (progressBarStatus) {
          barWrapper.innerHTML = stringToHTML(barRewards["cart-bar-rewards"]).outerHTML;
        }

        btn.querySelector(".loading-overlay__spinner").remove();
        // setTimeout(() => {
        //   initializeUpsell();
        // }, 1000);
      }

    })
    .catch((error) => console.error(error));
};

const swiper = () => {
  // Initialize the swiper slider
  let myPagination = document.querySelector(`.swiper-pagination.custom.upsell`);
  let navigationObj;

  const paginationObj = {
    el: myPagination,
    clickable: true,
  };
  
  if (navigationArrows) {
	navigationObj = {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	};
  }else{
	navigationObj = { navigation: false }
  }

  const slider = new Swiper(".upsell__swiper", {
    slidesPerView: 1.1,
    // centeredSlides: true,
    spaceBetween: 20,
    // loop: true,
    pagination: paginationObj,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: true,
    //   pauseOnMouseEnter: true,
    // },
	navigation: navigationObj,
    breakpoints: {
      1000: {
        slidesPerView: 3,
        // centeredSlides: false,
        direction: "vertical",
        grabCursor: true,
        // height: 868,
        spaceBetween: 40,
      },
    },
  });
  return slider;
};

const support = () => {
  if (!window.DOMParser) return false;
  const parser = new DOMParser();
  try {
    parser.parseFromString("x", "text/html");
  } catch (err) {
    return false;
  }
  return true;
};

const stringToHTML = (str) => {
  // If DOMParser is supported, use it
  if (support()) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(str, "text/html");
    return doc.body;
  }
  // Otherwise, fallback to old-school method
  const dom = document.createElement("div");
  dom.innerHTML = str;
  return dom;
};

document.addEventListener('DOMContentLoaded' , initializeUpsell());